import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PredesTransactionsObjectDialog from './PredesTransactionsObjectDialog';

class PredesTransactionsObject extends Component {
  render() {
    return (
      <div>
        <PredesTransactionsObjectDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

PredesTransactionsObject.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default PredesTransactionsObject;
